/** Public site brand and URL — single source of truth */
export const SITE_NAME = 'MineMe';
export const SITE_URL = 'https://mineme.site';

/** Canonical public origin (env SITE_URL in production, fallback above). */
export function getPublicSiteUrl() {
  const raw = typeof process !== 'undefined' ? String(process.env.SITE_URL || '').trim() : '';
  if (raw && /^https?:\/\//i.test(raw)) return raw.replace(/\/$/, '');
  return SITE_URL;
}

/** Public marketing page for sector directory (formerly /partners) */
export const INVESTMENT_SECTORS_PATH = '/investment-sectors';

export const SITE_TAGLINE = 'High-Yield Investment Platform';

export const DEFAULT_DESCRIPTION =
  'MineMe is your gateway to expertly managed investment sectors in crypto mining, bullion trading, pharmaceuticals, and AI infrastructure.';

/** Approved client logos in /public/logo (PNG, 1024×1024) */
export const LOGO_DARK_SRC = '/logo/logo-dark.png';
export const LOGO_LIGHT_SRC = '/logo/logo-light.png';

export const DEFAULT_OG_IMAGE = `${SITE_URL}${LOGO_DARK_SRC}`;

export const SITE_LOCALE = 'en_US';

export const TWITTER_HANDLE = ''; // e.g. '@mineme' when available

export const SITE_KEYWORDS =
  'MineMe, high-yield investment, crypto mining, bullion trading, pharmaceuticals, AI infrastructure, investment platform';
